module.exports = __webpack_public_path__ + "static/media/certificate.a5b119e8.svg";